module.exports = __webpack_public_path__ + "img/sinistre_mobile.64994802.jpg";